import { render, staticRenderFns } from "./VenPL_List.vue?vue&type=template&id=4306b8b5"
import script from "./VenPL_List.vue?vue&type=script&lang=js"
export * from "./VenPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports